module.exports = __webpack_public_path__ + "img/reward-stickers.a4e1c88f.png";